export const meta: BlockMeta = {
  title: "Newsletter Subscribe",
  tags: ["#page"],
}

import { Button } from "@components/atoms/Button"
import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText } from "eddev/blocks"
import { useEffect, useRef } from "react"

export default defineBlock("content/newsletter-subscribe", (props) => {
  const formRef = useRef<HTMLFormElement>(null)

  useEffect(() => {
    const form = formRef.current
    if (!form) return

    const script = document.createElement("script")
    script.src = "https://js.createsend1.com/javascript/copypastesubscribeformlogic.js"
    script.async = true
    form.appendChild(script)

    return () => {
      form.removeChild(script)
    }
  }, [])

  return (
    <div className="w-full flex flex-col items-center bg-white relative z-50">
      <Appear className="content-sized py-11 border-t border-t-concrete relative flex flex-col gap-8 md:gap-7">
        <div className="w-full flex flex-col gap-7 md:gap-4 pt-11">
          <EditableText
            as="h3"
            store="title"
            className="type-mobile-headings-heading-xs md:type-desktop-headings-heading-xs"
            placeholder="Subscribe"
            defaultValue="Subscribe"
          />
          <EditableText
            as="p"
            store="description"
            className="type-mobile-headings-heading-l md:type-desktop-headings-heading-l md:max-w-[75%]"
            placeholder="Stay up to date with our latest projects, insights, and achievements — making news."
            defaultValue="Stay up to date with our latest projects, insights, and achievements — making news."
          />
        </div>
        <form
          ref={formRef}
          className="js-cm-form w-full flex flex-col md:flex-row gap-5 md:gap-4"
          id="subForm"
          action="https://www.createsend.com/t/subscribeerror?description="
          method="post"
          data-id="2BE4EF332AA2E32596E38B640E9056197B5084DEBFF738E545D7CBDA66097463117A9A6B68D1215CDFC60ED7486CAC293B2619003E56E85EC9EAC91EB7F1D4C0"
        >
          <input
            className="sc-gZMcBi dshyOS appearance-none bg-stone50 placeholder:opacity-100 placeholder:text-concrete400 text-black p-4 md:p-3 type-desktop-label-label-l outline-none"
            placeholder="Full Name"
            id="fieldName"
            maxLength={200}
            name="cm-name"
          />
          <input
            className="js-cm-email-input qa-input-email sc-gZMcBi dshyOS appearance-none bg-stone50 placeholder:opacity-100 placeholder:text-concrete400 text-black p-4 md:p-3 type-desktop-label-label-l outline-none"
            placeholder="Email Address"
            type="email"
            autoComplete="Email"
            id="fieldEmail"
            maxLength={200}
            name="cm-yuiukyj-yuiukyj"
            required
          />
          <Button className="js-cm-submit-button sc-brqgnP dwYSlG ml-2" type="submit">
            Subscribe
          </Button>
        </form>
      </Appear>
    </div>
  )
})
